/**
 * /recipes — the kitchen's day-grouped make-list (batch prep look-ahead).
 *
 * Aug 2026 chef-sidebar split: this page IS the old Shopping List's
 * Recipes tab, promoted to its own sidebar row. The previous universal
 * recipe-catalog browser (Plan 08) was removed with it — the shared
 * recipe detail panel (`components/recipes/recipe-detail-slot`) lives
 * on as this page's side peek.
 *
 * Implementation is shared with /shopping-list and /deliverables —
 * see `ChefKitchenPage` in `pages/shopping-list.tsx`.
 */

import { ChefKitchenPage } from '@/pages/shopping-list'

export function RecipesPage() {
  return <ChefKitchenPage view="recipes" />
}
